import { tv } from 'tailwind-variants';

/** Button recipe (CLAUDE.md §6.8). At most one primary button per view or dialog. */
export const buttonStyles = tv({
  base: [
    'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md font-medium whitespace-nowrap select-none',
    'transition-colors duration-100 outline-none focus-visible:ring-2 focus-visible:ring-focus',
    'disabled:pointer-events-none disabled:opacity-45',
    '[&_svg]:size-4 [&_svg]:shrink-0',
  ],
  variants: {
    variant: {
      primary: 'bg-accent text-accent-fg hover:bg-accent-hover',
      secondary:
        'border border-border-strong bg-bg-2 text-text-1 hover:bg-bg-3 aria-expanded:bg-bg-3',
      ghost:
        'text-text-2 hover:bg-bg-3 hover:text-text-1 aria-expanded:bg-bg-3 aria-expanded:text-text-1',
      danger: 'bg-status-critical text-on-solid hover:brightness-110',
    },
    size: {
      sm: 'h-6 px-2 text-xs',
      md: 'h-7 px-2.5 text-sm',
      lg: 'h-8 px-3 text-sm',
    },
    iconOnly: {
      true: 'px-0',
    },
  },
  compoundVariants: [
    { iconOnly: true, size: 'sm', class: 'w-6' },
    { iconOnly: true, size: 'md', class: 'w-7' },
    { iconOnly: true, size: 'lg', class: 'w-8' },
  ],
  defaultVariants: { variant: 'secondary', size: 'md' },
});
